<script setup lang="ts">
import { onMounted, ref } from 'vue';
import type { GraphqlDatatableColumn } from './GqlDatatable.vue';
import { useAuthStore } from '~/stores/auth';
import { isNilOrEmpty } from '~/utils';

const props = defineProps({
  compromisso: {
    default: null,
    type: Object,
  },
  pastaCodigos: {
    default: () => null,
    type: Array,
  },
});

const emit = defineEmits(['close', 'loaded', 'success', 'error']);

const submitStatus = ref<any>(null);
const mostrarHistoricoSolicitacoes = ref<any>('h');

const colunas = [
  {
    key: 'compromisso',
    title: 'COMPROMISSO',
    width: 120,
  },
  {
    key: 'responsavel',
    title: 'RESPONSÁVEL',
    width: 120,
  },
  {
    dataIndex: 'dataInicioText',
    key: 'dataInicio',
    sortBy: ['dataInicio'],
    sorter: true,
    title: 'SOLICITADO EM',
    width: 120,
    defaultSortOrder: 'descend',
  },
  {
    dataIndex: 'dataVencimentoText',
    key: 'dataVencimento',
    sortBy: ['dataVencimento'],
    sorter: true,
    title: 'VENCIMENTO EM',
    width: 120,
  },
  {
    dataIndex: 'dataConclusaoText',
    key: 'dataConclusao',
    sortBy: ['dataConclusao'],
    sorter: true,
    title: 'CONCLUÍDO EM',
    width: 120,
  },
] as GraphqlDatatableColumn[];

const authStore = useAuthStore();

async function postSubmit()
{
  submitStatus.value = 'success';
}

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <div>
    <div v-if="submitStatus !== 'success'">
      <a-collapse
        v-if="props.pastaCodigos?.length === 1"
        v-model:activeKey="mostrarHistoricoSolicitacoes"
      >
        <a-collapse-panel
          key="h"
          header="HISTÓRICO DE SOLICITAÇÕES"
        >
          <CompromissoGqlDatatable
            :columns="colunas"
            :show-dates-filter="false"
            :show-reload-button="false"
            :show-status-search-bar="false"
            :show-filter="false"
            :variables="{
              order: [{ dataInicio: 'DESC' }],
              where: {
                tipo: {
                  eq: 35,
                },
                fluxo: {
                  pastaCodigo: {
                    in: props.pastaCodigos,
                  },
                },
              },
            }"
          />
        </a-collapse-panel>
      </a-collapse>
    </div>

    <div style="margin-top: 16px" />

    <CompromissoCommandForm2
      command="AlteracaoPasta.SolicitarAlteracaoPastaCommand"
      :post-submit="postSubmit"
      :submit-button-disabled="!isNilOrEmpty(compromisso)
        && compromisso.responsavel.codigo !== authStore.codigoUsuario"
      :initial-model="{
        pastaCodigos: props.pastaCodigos,
        compromissoCodigos: props.compromisso ? [props.compromisso.codigo] : null,
      }"
      @close="() => emit('close')"
      @submit-success="() => emit('success')"
    >
      <template #form="{ model }">
        <a-form-item
          label="Descrição"
          name="descricao"
          style="padding-bottom: 0"
          :rules="[{ message: 'Descrição é obrigatório', required: true }]"
        >
          <a-textarea
            v-model:value="model.descricao"
            :rows="4"
          />
        </a-form-item>
      </template>
    </CompromissoCommandForm2>
  </div>
</template>
